import { render } from "./ContentView.vue?vue&type=template&id=3b001841&scoped=true"
import script from "./ContentView.vue?vue&type=script&lang=js"
export * from "./ContentView.vue?vue&type=script&lang=js"

import "./ContentView.vue?vue&type=style&index=0&id=3b001841&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b001841"]])

export default __exports__